import { Box } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { UnpackNestedValue, DeepPartial, SubmitHandler, useForm, FormProvider, FieldValues } from 'react-hook-form';

interface AppFormProps<T extends FieldValues> {
  id: string;
  defaultForm: UnpackNestedValue<DeepPartial<T>>;
  onSubmit: SubmitHandler<T>;
  height?: string;
}

export function AppForm<T extends FieldValues>({
  children,
  defaultForm,
  onSubmit,
  id,
  height = 'inherit',
}: PropsWithChildren<AppFormProps<T>>) {
  const methods = useForm<T>({ defaultValues: defaultForm });
  return (
    <FormProvider {...methods}>
      <Box component='form' sx={{ height }} id={id} onSubmit={methods.handleSubmit(onSubmit)}>
        {children}
      </Box>
    </FormProvider>
  );
}
